// ** Logo
import logo from "@src/assets/images/logo/2.png";
import whitelogo from "@src/assets/images/logo/logo-white-compressed.png";
import './fstyle.scss'


const Spinn = () => {

		return (
			<div className="d-flex justify-content-center align-items-center background-glassf w-100 h-100">
				<div className="fallback-spinnerf app-loaderf background-lightf  position-absolute top-50 start-50 translate-middle ">
					<img className="fallback-logof  position-absolute top-50 start-50 translate-middle " src={window.localStorage.skin === '"dark"' ? whitelogo : logo} alt="logo" style={{ width: 100 }}/>
					<div className="loadingf  position-absolute top-50 start-50 translate-middle ">
						<div className="effect-1f effectsf"></div>
						<div className="effect-2f effectsf"></div>
						<div className="effect-3f effectsf"></div>
					</div>
				</div>
			</div>
			)
};

export default Spinn;
